import { render } from "./ReportTemplateList.vue?vue&type=template&id=27751d98&scoped=true"
import script from "./ReportTemplateList.vue?vue&type=script&lang=js"
export * from "./ReportTemplateList.vue?vue&type=script&lang=js"

import "./ReportTemplateList.vue?vue&type=style&index=0&id=27751d98&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27751d98"]])

export default __exports__